import React, { useEffect } from 'react';
import Dragger from 'draggerjs'
import { SectionWithCode, Note } from 'Templates';
import * as code from '../StringCodes'; 

export const Switching = () => {

    useEffect(() => {
        let clone
        const switchingAlgorithm = (e, elementToInsert) => {
            const droppable = e.droppable && e.droppable.closest('.switching-box')
            const currentDroppable = e.currentDroppable  
            if(droppable && currentDroppable 
                && droppable !== elementToInsert 
                && droppable !== currentDroppable) {

                const droppableRect = droppable.getBoundingClientRect()
                const isFirstChild = currentDroppable.firstElementChild === droppable
                const isLastChild = currentDroppable.lastElementChild === droppable
                const divident = isFirstChild ? 0 : isLastChild ? droppableRect.height : 2
                /*the clone positioning is base on y axis*/
                const isBefore = e.clientY - droppableRect.top < droppableRect.height/divident
                const next = droppable.nextElementSibling
                if(!next && !isBefore) {
                    currentDroppable.appendChild(elementToInsert)
                }
                currentDroppable.insertBefore(elementToInsert, isBefore ? droppable : next )
            }
        }

        const dragger = new Dragger('.switching-area', {
            draggable: '.switching-box',
            droppable: '.switching-area',
            axis: 'y',
        })
        
        dragger.on('dragstart', (e) => {
            const target = e.target
            if(e.isDraggableElement) {
                e.preventDefault() 
                clone && clone.remove()
                clone = target.cloneNode(true)
                clone.classList.add('drag-clone')
                clone.classList.remove('n-flat-low')
                target.closest('.switching-area').insertBefore(clone, e.target )
                target.classList.add('grabbed')
                target.classList.add('n-float-low')
                target.classList.remove('n-flat-low')  
            }
           
        })
        dragger.on('dragover', (e) => { 
            switchingAlgorithm(e, clone)
        })  
        dragger.on('drop', (e) => {
            const target = e.target  
            if(e.isDraggableElement) {  
                switchingAlgorithm(e, target) 
            } 
        })
        dragger.on('dragend', (e) => {
            const target = e.target
            if(e.isDraggableElement) { 
                clone.remove()
                Array.from(e.container.children)
                    .forEach((each, i) => each.dataset.index = i + 1)
                setTimeout(() => {
                    target.classList.add('n-flat')
                    target.classList.remove('n-float')
                    target.classList.remove('grabbed')
                }, 0)
            }
        })
        return () => dragger.destroy()
    }, [])

    return (
        <>  
            <SectionWithCode
                readonly
                title='Switching'
                context='you can do switching as well.'
                code={code.Switching}
            >  
                <ul className="switching-area" data-example>
                    <li className="switching-box n-no-shadow n-flat-low" data-index="1">
                        <h5>Apple</h5>
                    </li>
                    <li className="switching-box n-no-shadow n-flat-low" data-index="2">
                        <h5>Peach</h5>
                    </li> 
                    <li className="switching-box n-no-shadow n-flat-low" data-index="3">
                        <h5>Orange</h5>
                    </li>
                    <li className="switching-box n-no-shadow n-flat-low" data-index="4">
                        <h5>Grapes</h5>
                    </li>
                    <li className="switching-box n-no-shadow n-flat-low" data-index="5">
                        <h5>Banana</h5>
                    </li>
                </ul>  
                <Note
                    variant='warning'
                    title='remember'
                    context={<>When using <b>droppable</b> make sure to add <b>[hidden] {'{'} display: none !important; {'}'}</b> in your stylesheet. due to some changes in browsers which <b>hidden</b> property gets overridden.</>}
                    style={{ marginTop: '20px' }}
                />
            </SectionWithCode>
        </>
    );
}